import {
  Col,
  Form,
  Row,
  Space,
  Divider,
  Input,
  DatePicker,
  InputNumber,
} from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Button from 'components/Button';
import { useEffect, useState } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import AllocateCreate from 'pages/Branch/Allocate/AllocateCreate';
import moment from 'moment';
import { useUser } from 'contexts/User';
import { useMutation } from 'react-query';
import AllocateApi from 'apis/AllocateApi';
import { openNotificationWithIcon } from 'utils/notification';
import dayjs from 'dayjs';
import { useForm } from 'antd/es/form/Form';
interface Iparam {
  id?: string;
}

export default function StepDeclare(): JSX.Element {
  const history = useHistory();
  const [form] = useForm();
  const allocateData = useLocation().state as any;
  // const [allocateDetail, setAllocateDetail] = useState<any>(
  //   allocateData.btn == 'Edit' ? allocateData.allocationDetailData : undefined
  // );
  const { id } = useParams<Iparam>();
  const { user } = useUser();
  const dateDefault = String(
    allocateData.allocationDetailData?.capital_year != undefined
      ? allocateData.allocationDetailData?.capital_year
      : new Date().getFullYear()
  );
  const dateFormat = 'YYYY';
  const setStep = useCategoryManagementStore((state) => state.setStep);
  const [declareDetail, setDeclareDeatail] = useState<any>(
    allocateData.btn == 'Edit' ? allocateData.allocationDetailData : undefined
  );
  const [checked, setChecked] = useState<boolean>(
    declareDetail?.capital_name != undefined &&
      declareDetail?.capital_value != undefined &&
      declareDetail?.capital_year != undefined
      ? false
      : true
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');

  useEffect(() => {
    setStep(0);
    if (user) {
      setDeclareDeatail({
        ...declareDetail,
        ['branch_id']: Number(user?.plantId),
        ['capital_year']: Number(dateDefault),
      });
    }
  }, [user]);

  useEffect(() => {
    setChecked(
      declareDetail?.capital_name != undefined &&
        declareDetail?.capital_value != undefined &&
        declareDetail?.capital_year != undefined
        ? false
        : true
    );
  }, [declareDetail]);
  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent('');
  };

  const onNextStep = () => {
    // if (products.length != 0) {
    closeModal();
    history.push(`/branchs-capital-create/list`);
    // } else {
    //   openModal('Chưa có sản phẩm nào được đồng bộ, vui lòng đồng bộ sản phẩm');
    // }
  };

  // function CheckOnChange() {
  //   setChecked(
  //     declareDetail?.capital_name != undefined &&
  //       declareDetail?.capital_value != undefined &&
  //       declareDetail?.capital_year != undefined
  //       ? false
  //       : true
  //   );
  // }

  function handleOnchangeYear(event: any) {
    if (event != null) {
      setDeclareDeatail({ ...declareDetail, capital_year: event.$y });
    } else {
      form.resetFields();
    }
    // CheckOnChange();
  }

  function handleOnchangeValue(event: any, string: any): void {
    if (string == 'capital_name') {
      if (event.target.value != '' && event.target.value != undefined)
        setDeclareDeatail({ ...declareDetail, [string]: event.target.value });
      else if (event.target.value == '')
        setDeclareDeatail({ ...declareDetail, [string]: undefined });
    } else {
      if (event != '' && event != undefined)
        setDeclareDeatail({ ...declareDetail, [string]: event });
      else if (event == null)
        setDeclareDeatail({ ...declareDetail, [string]: undefined });
    }
    // CheckOnChange();
  }

  const { mutate: updateAllocation } = useMutation(
    AllocateApi.updateAllocationInfo,
    {
      onSuccess: (res: any) => {
        console.log(res);
        if (res?.status == 'success') {
          // openNotificationWithIcon('success', 'Thêm mới thành công');
          history.push(`/branchs-capital-create/list`, allocateData);
        } else {
          openNotificationWithIcon('error', res.message);
        }
      },
      onError: (e: any) => {
        openNotificationWithIcon('error', e.toString());
      },
    }
  );

  const handlecreateAllocation = async () => {
    if (allocateData.btn == 'Create') {
      history.push(`/branchs-capital-create/list`, {
        declareDetail: declareDetail,
        btn: allocateData.btn,
      });
      // createAllocation(declareDetail);
    }
    // else if (allocateData.btn == 'Edit') {
    //   if (
    //     declareDetail.capital_year !=
    //       allocateData.allocationDetailData.capital_year ||
    //     declareDetail.capital_value !=
    //       allocateData.allocationDetailData.capital_value ||
    //     declareDetail.capital_name !=
    //       allocateData.allocationDetailData.capital_name
    //   ) {
    //     updateAllocation(declareDetail);
    //   } else history.push(`/branchs-capital-create/list`, allocateData);
    // }
  };

  return (
    <AllocateCreate>
      <Form
        layout="vertical"
        className="items-center"
        onFinish={onNextStep}
        autoComplete="off"
      >
        <Content>
          <Row justify="space-between" align="middle">
            <Col span={24}>
              <div className="text-xl font-bold">1. Khai báo vốn chi nhánh</div>
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="mt-4"
            style={{ marginLeft: '5px' }}
          >
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={8}>
                  Người phân bố
                </Col>
                <Col className="text-base font-semibold" span={16}>
                  : {user?.fullName}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={8}>
                  Email
                </Col>
                <Col className="text-base font-semibold" span={16}>
                  : {user?.email}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="mt-4"
            style={{ marginLeft: '5px' }}
          >
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={8}>
                  Khu Vực
                </Col>
                <Col className="text-base font-semibold" span={16}>
                  : {user?.division}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={8}>
                  Mã chi nhánh
                </Col>
                <Col className="text-base font-semibold" span={16}>
                  : {user?.plantCode}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="mt-4"
            style={{ marginLeft: '5px' }}
          >
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={8}>
                  Chi nhánh
                </Col>
                <Col className="text-base font-semibold" span={16}>
                  : {user?.plantName}
                </Col>
              </Row>
            </Col>
          </Row>

          <Divider
            style={{
              borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
              marginTop: '8px',
              marginBottom: '8px',
            }}
            dashed
          />

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mt-4">
            <Col className="" span={12}>
              <Form.Item
                name="year"
                label="Năm"
                rules={[{ required: true, message: 'Không được để trống' }]}
              >
                <DatePicker
                  placeholder="yyyy"
                  className="ant-input"
                  format={dateFormat}
                  picker="year"
                  defaultValue={dayjs(dateDefault, 'YYYY')}
                  disabledDate={(current) => {
                    return moment().add(0, 'years') >= current;
                  }}
                  onChange={(event) => handleOnchangeYear(event)}
                />
              </Form.Item>
            </Col>
            <Col className="" span={12}>
              <Form.Item
                name="allocated_name"
                label="Tên phân bổ"
                rules={[
                  {
                    required: true,
                    message: 'Không được để trống',
                  },
                ]}
              >
                <Input
                  placeholder="Nhập tên phân bổ"
                  className=""
                  defaultValue={declareDetail?.capital_name}
                  onChange={(event) =>
                    handleOnchangeValue(event, 'capital_name')
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Divider
            style={{
              borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
              marginTop: '8px',
              marginBottom: '8px',
            }}
            dashed
          />

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={12}>
              <Form.Item
                name="capital_value"
                label="Tổng vốn chi nhánh"
                rules={[
                  {
                    required: true,
                    message: 'Không được để trống',
                  },
                ]}
              >
                <InputNumber
                  addonAfter="VNĐ"
                  placeholder="Nhập số tiền"
                  defaultValue={declareDetail?.capital_value}
                  style={{ width: '100%' }}
                  size="large"
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                  onChange={(event) =>
                    handleOnchangeValue(event, 'capital_value')
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Content>
        <Divider
          style={{
            borderTop: '1px solid rgba(0, 0, 0, 0.2)',
            marginTop: '8px',
            marginBottom: '8px',
          }}
        />
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
          <Col
            className="flex justify-end"
            span={8}
            style={{ marginTop: '20px', marginRight: '2px' }}
          >
            <Button
              onClick={() =>
                history.push(`/branchs-capital-detail`, allocateData)
              }
            >
              Trở lại
            </Button>
            <Button
              // type="submit"
              disabled={checked}
              bgColor={checked == false ? 'bg-primary-50' : 'bg-gray-300'}
              onClick={handlecreateAllocation}
            >
              Tiếp theo
            </Button>
          </Col>
        </Row>
      </Form>
    </AllocateCreate>
  );
}
